import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setDefaultRefreshAlert } from "../../features/DisplayAlertRefreshInValidSlice";
export default function Alert({ message }) {
  const dispatch = useDispatch();
  const displayRefreshTokenAlert = useSelector(
    (state) => state.DisplayRefreshTokenAlert
  ).displayAlert;
  const [isVisible, setIsVisible] = useState(displayRefreshTokenAlert);

  const handleClose = () => {
    if (isVisible) {
      dispatch(setDefaultRefreshAlert());
      return setIsVisible(false);
    }
    return setIsVisible(true);
  };

  useEffect(() => {
    setIsVisible(displayRefreshTokenAlert);
    function defaultFun(params) {
      return;
    }
    setTimeout(() => {
      setIsVisible(false);
      dispatch(setDefaultRefreshAlert());
    }, 3000);
    return defaultFun();
  }, [displayRefreshTokenAlert, dispatch]);

  return isVisible ? (
    <div
      className={`alert h-[12vh] fixed top-[44vh] b-[44vh] w-full text-center py-3 bg-yellow-300/95 text-black/80 shadow-lg `}
    >
      <p>{message}</p>
      <button
        className={` bg-red-800 text-white font-bold rounded-lg shadow-lg px-3 py-1 hover:scale-105 ease-in duration-200 `}
        onClick={handleClose}
      >
        Close
      </button>
    </div>
  ) : (
    <></>
  );
}
